import React, { useEffect, useRef, useState } from 'react';
import { Carousel, Image } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from 'components/shared-components/Flex';
import { faPhone, faReply, faUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import { useMyContext } from 'Context/MyContextProvider';
import chatBackground from '../../../../assets/image/chat-bg.png';
import { renderBody } from '../Utils/utils';
const styles = {
  chatBackground: {
    backgroundImage: `url(${chatBackground})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    borderRadius: '8px',
    padding: '16px',
    // height:'100%'
  },

  chatBubble: {
    background: 'white',
    borderRadius: '8px',
    padding: '8px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
    position: 'relative',
    marginLeft: '20px',
    maxWidth: '85%',
    wordWrap: 'break-word',
  },
  buttoneBubble: {
    background: 'white',
    borderRadius: '8px',
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,

    // padding: '16px',
    boxShadow: '0 8px 8px -4px rgba(0, 0, 0, 0.15)',
    position: 'relative',
    bottom: '0.5rem',
    marginLeft: '20px',
    maxWidth: '85%',
    wordWrap: 'break-word',
  },
  chatBubbleBefore: {
    content: '""',
    position: 'absolute',
    top: '0',
    left: '-5px',
    width: '0',
    height: '0',
    borderStyle: 'solid',
    borderWidth: '10px 10px 10px 0',
    borderColor: 'transparent white transparent transparent',
    background: '#ffff',
    backgroundColor: '#ffff',
    clipPath: 'polygon(0 0, 0 100%, 100% 100%)',
    transform: 'rotate(180deg)',


  },
  chatTime: {
    textAlign: 'right',
    fontSize: '12px',
    color: 'gray',
    // marginTop: '4px',
  },
  footerMessageStyle: {
    fontSize: '12px',
    marginTop: '5px',
    color: '#918f8f'
  },
  buttonStyle: {
    // fontSize: '11px',
    wordWrap: 'break-word',
    fontFamily: 'system-ui',
    display: 'block',
    textAlign: 'justify',
  }
};
const CarouselPreview = ({ isLoop, mainBody, mediaLink, cards, currentCardIndex, requiredMedia = true, dynamicValues = [] }) => {
  const { getMedia, getUrlFromMediaId } = useMyContext()
  // mobile preview style 
  const carouselRef = useRef(null);
  const [displayText, setDisplayText] = useState('');
  const [currentTime, setCurrentTime] = useState('');
  const [media, setMedia] = useState([]);

  useEffect(() => {
    setDisplayText(mainBody?.text || mainBody?.bodyText);
  }, [mainBody]);

  useEffect(() => {
    if (carouselRef.current && currentCardIndex !== undefined) {
      carouselRef.current.goTo(currentCardIndex);
    }
  }, [currentCardIndex]);

  useEffect(() => {
    requiredMedia && getMedia(setMedia)
    const updateCurrentTime = () => {
      const now = new Date();
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      setCurrentTime(`${hours}:${minutes}`);
    };

    updateCurrentTime();
    const interval = setInterval(updateCurrentTime, 60000);
    return () => clearInterval(interval);
  }, []);


  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-200">
      <div style={styles.chatBackground}>
        <div style={styles.chatBubble}>
          <div style={styles.chatBubbleBefore} />
          {displayText && renderBody(displayText, dynamicValues)}
          <div style={styles.chatTime}>{currentTime}</div>
        </div>
        <Carousel
          ref={carouselRef}
          dots={false}
          autoplay={isLoop}
          draggable>
          {cards?.map((item, index) => (
            <div key={index} className='mt-1'>
              <div style={styles.chatBubble}>
                {(item?.header?.format || item?.header?.type) === 'DOCUMENT' ?
                  <div className='border rounded d-flex justify-content-center align-items-center mb-3' style={{ background: '#ccd0d5' }}>
                    <img
                      src={'/img/pdfBackground.png'}
                      className='my-3'
                      width={"100%"}
                      height={"200px"}
                      alt='pdf'
                    />
                  </div>
                  :
                  (item?.header?.format || item?.header?.type) === 'IMAGE' ?
                    <>
                      {mediaLink?.length > 0 ?
                        <>
                          <Image
                            src={mediaLink[index] ? getUrlFromMediaId(mediaLink[index], media) : '/img/others/dummy-header.jpg'}
                            className='mt-1 rounded'
                            loading='lazy'
                          />
                        </>
                        :
                        <Image
                          src={'/img/others/dummy-header.jpg'}
                          preview={false}
                          loading='lazy'
                          width={"100%"}
                          height={"200px"}
                          className='mt-1 rounded' />
                      }
                    </>
                    :
                    item?.header && (item?.header?.format || item?.header?.type) === 'VIDEO' ?
                      <div className=' d-flex justify-content-center align-items-center mb-3' style={{ background: '' }}>
                        <Image
                          src={'/img/dummyvideo.png'}
                          className='mt-1 border rounded'
                          alt='video'
                          width={'100%'}
                          height={'200px'}
                        />
                      </div>
                      :
                      <div className='header'>
                        <h5>{item?.header?.text}</h5>
                      </div>

                }
                <Flex flexDirection='column' gap='10px'>
                  {renderBody(item?.body?.text)}
                  <span className='text-gray-light h6 text-center'>Card {index + 1}</span>
                </Flex>
              </div>
              <div style={styles.buttoneBubble}>
                {/* First, check if buttons exist in either format */}
                {((Array.isArray(item?.buttons) && item?.buttons.length > 0) ||
                  (item?.buttons?.buttons && Array.isArray(item?.buttons?.buttons) && item?.buttons?.buttons.length > 0)) ?

                  // Determine which buttons array to use
                  (item?.buttons?.buttons || item?.buttons)?.map((button, btnIndex) => {
                    // Skip buttons with empty text
                    if (!button?.text) return null;

                    // Display the first 2 QUICK_REPLY buttons and all other buttons
                    if (button?.type === "QUICK_REPLY" && btnIndex < 2) {
                      return (
                        <span style={styles.buttonStyle} className="border-top py-2" key={btnIndex}>
                          <button className="border-0 bg-transparent w-100" style={{ fontWeight: 'bold', color: '#00a5f4' }}>
                            <Flex justifyContent='center' alignItems='center' gap='5px'>
                              <FontAwesomeIcon icon={faReply} />
                              <span>{button?.text}</span>
                            </Flex>
                          </button>
                        </span>
                      );
                    } else if (button?.type !== "QUICK_REPLY") {
                      return (
                        <span style={styles.buttonStyle} className="border-top py-2" key={btnIndex}>
                          <button className="border-0 bg-transparent w-100" style={{ fontWeight: 'bold', color: '#00a5f4' }}>
                            <Flex justifyContent='center' alignItems='center' gap='5px'>
                              {button?.type === "PHONE_NUMBER" && <FontAwesomeIcon icon={faPhone} />}
                              {button?.type === "URL" && <FontAwesomeIcon icon={faUpRightFromSquare} />}
                              <span>{button?.text}</span>
                            </Flex>
                          </button>
                        </span>
                      );
                    }
                    return null;
                  })
                  : null
                }
              </div>
            </div>
          ))}
        </Carousel>
      </div>
    </div>
  )
}

export default CarouselPreview
